export const adiquimicaConfiguration = {
  adiquimica_configurations: `Configuraciones de Adiquimica`,
  connected_databases: `Bases de datos conectadas`,
  "add_single_or_multiple_database(s)_by_pressing_enter": `Agregue una o varias bases de datos presionando Enter`,
};
